<template>
  <BaseButton ghost small @click="open"> Delete </BaseButton>
</template>

<script>
import { projectAssetApprovalClaimsClient } from '@/api/clients';

export default {
  props: {
    approvalClaimId: {
      type: String,
      required: true,
    },
    projectAssetId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('./ApprovalClaimDeleteModal.vue'),
        props: {
          action: async () => {
            this.loading = true;

            try {
              await projectAssetApprovalClaimsClient.destroy(
                this.projectAssetId,
                this.approvalClaimId
              );

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            } finally {
              this.loading = false;
            }
          },
        },
        on: {
          'approval-claim-deleted': () => {
            this.$emit('approval-claim-deleted');
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
